import { render, staticRenderFns } from "./PartesCalendar.vue?vue&type=template&id=37c754c7&scoped=true"
import script from "./PartesCalendar.vue?vue&type=script&lang=js"
export * from "./PartesCalendar.vue?vue&type=script&lang=js"
import style0 from "./PartesCalendar.vue?vue&type=style&index=0&id=37c754c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c754c7",
  null
  
)

export default component.exports